var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_769_3956",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 2H2V18H18V2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.90625 7.9375C5.56106 7.9375 5.28125 8.21732 5.28125 8.5625C5.28125 8.90769 5.56106 9.1875 5.90625 9.1875C6.25143 9.1875 6.53125 8.90769 6.53125 8.5625C6.53125 8.21732 6.25143 7.9375 5.90625 7.9375Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 7.9375C8.27981 7.9375 8 8.21732 8 8.5625C8 8.90769 8.27981 9.1875 8.625 9.1875C8.97018 9.1875 9.25 8.90769 9.25 8.5625C9.25 8.21732 8.97018 7.9375 8.625 7.9375Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3437 7.9375C10.9986 7.9375 10.7188 8.21732 10.7188 8.5625C10.7188 8.90769 10.9986 9.1875 11.3437 9.1875C11.6889 9.1875 11.9687 8.90769 11.9687 8.5625C11.9687 8.21732 11.6889 7.9375 11.3437 7.9375Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 7.9375C13.7173 7.9375 13.4375 8.21732 13.4375 8.5625C13.4375 8.90769 13.7173 9.1875 14.0625 9.1875C14.4077 9.1875 14.6875 8.90769 14.6875 8.5625C14.6875 8.21732 14.4077 7.9375 14.0625 7.9375Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53125 11.2813C6.53125 10.9361 6.25143 10.6563 5.90625 10.6563C5.56106 10.6563 5.28125 10.9361 5.28125 11.2813C5.28125 11.6264 5.56106 11.9062 5.90625 11.9062C6.25143 11.9062 6.53125 11.6264 6.53125 11.2813Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53125 14C6.53125 13.6548 6.25143 13.375 5.90625 13.375C5.56106 13.375 5.28125 13.6548 5.28125 14C5.28125 14.3452 5.56106 14.625 5.90625 14.625C6.25143 14.625 6.53125 14.3452 6.53125 14Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 11.2813C9.25 10.9361 8.97018 10.6563 8.625 10.6563C8.27981 10.6563 8 10.9361 8 11.2813C8 11.6264 8.27981 11.9062 8.625 11.9062C8.97018 11.9062 9.25 11.6264 9.25 11.2813Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 14C9.25 13.6548 8.97018 13.375 8.625 13.375C8.27981 13.375 8 13.6548 8 14C8 14.3452 8.27981 14.625 8.625 14.625C8.97018 14.625 9.25 14.3452 9.25 14Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 7.9375C8.27981 7.9375 8 8.21732 8 8.5625C8 8.90769 8.27981 9.1875 8.625 9.1875C8.97018 9.1875 9.25 8.90769 9.25 8.5625C9.25 8.21732 8.97018 7.9375 8.625 7.9375Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 11.2813C9.25 10.9361 8.97018 10.6563 8.625 10.6563C8.27981 10.6563 8 10.9361 8 11.2813C8 11.6264 8.27981 11.9062 8.625 11.9062C8.97018 11.9062 9.25 11.6264 9.25 11.2813Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 14C9.25 13.6548 8.97018 13.375 8.625 13.375C8.27981 13.375 8 13.6548 8 14C8 14.3452 8.27981 14.625 8.625 14.625C8.97018 14.625 9.25 14.3452 9.25 14Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9687 11.2813C11.9687 10.9361 11.6889 10.6563 11.3437 10.6563C10.9986 10.6563 10.7188 10.9361 10.7188 11.2813C10.7188 11.6264 10.9986 11.9062 11.3437 11.9062C11.6889 11.9062 11.9687 11.6264 11.9687 11.2813Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6875 11.2813C14.6875 10.9361 14.4077 10.6563 14.0625 10.6563C13.7173 10.6563 13.4375 10.9361 13.4375 11.2813C13.4375 11.6264 13.7173 11.9062 14.0625 11.9062C14.4077 11.9062 14.6875 11.6264 14.6875 11.2813Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_769_3956)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_769_3956",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 16,
    height: 16
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4 17.4V2.6H2.6V17.4H17.4Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_769_3956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.74998 17.375H4.49999C3.46447 17.375 2.625 16.5355 2.625 15.5V5.75002C2.625 4.71449 3.46447 3.87503 4.49999 3.87503H15.5C16.5355 3.87503 17.375 4.71449 17.375 5.75002V10.1875",
    stroke: "#355C9D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.90625 7.9375C5.56106 7.9375 5.28125 8.21732 5.28125 8.5625C5.28125 8.90769 5.56106 9.1875 5.90625 9.1875C6.25143 9.1875 6.53125 8.90769 6.53125 8.5625C6.53125 8.21732 6.25143 7.9375 5.90625 7.9375Z",
    fill: "#355C9D",
    stroke: "#355C9D",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62497 8.5375C8.61115 8.5375 8.59997 8.54869 8.59997 8.5625C8.59997 8.57632 8.61115 8.5875 8.62497 8.5875C8.63878 8.5875 8.64997 8.57632 8.64997 8.5625C8.64997 8.54869 8.63878 8.5375 8.62497 8.5375Z",
    fill: "#355C9D",
    stroke: "#355C9D",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3437 7.9375C10.9985 7.9375 10.7187 8.21732 10.7187 8.5625C10.7187 8.90769 10.9985 9.1875 11.3437 9.1875C11.6889 9.1875 11.9687 8.90769 11.9687 8.5625C11.9687 8.21732 11.6889 7.9375 11.3437 7.9375Z",
    fill: "#355C9D",
    stroke: "#355C9D",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 7.9375C13.7173 7.9375 13.4375 8.21732 13.4375 8.5625C13.4375 8.90769 13.7173 9.1875 14.0625 9.1875C14.4077 9.1875 14.6875 8.90769 14.6875 8.5625C14.6875 8.21732 14.4077 7.9375 14.0625 7.9375Z",
    fill: "#355C9D",
    stroke: "#355C9D",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53125 11.2813C6.53125 10.9361 6.25143 10.6563 5.90625 10.6563C5.56106 10.6563 5.28125 10.9361 5.28125 11.2813C5.28125 11.6264 5.56106 11.9062 5.90625 11.9062C6.25143 11.9062 6.53125 11.6264 6.53125 11.2813Z",
    fill: "#355C9D",
    stroke: "#355C9D",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53125 14C6.53125 13.6548 6.25143 13.375 5.90625 13.375C5.56106 13.375 5.28125 13.6548 5.28125 14C5.28125 14.3452 5.56106 14.625 5.90625 14.625C6.25143 14.625 6.53125 14.3452 6.53125 14Z",
    fill: "#355C9D",
    stroke: "#355C9D",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.64997 11.2813C8.64997 11.2674 8.63878 11.2563 8.62497 11.2563C8.61115 11.2563 8.59997 11.2674 8.59997 11.2813C8.59997 11.2951 8.61115 11.3062 8.62497 11.3062C8.63878 11.3062 8.64997 11.2951 8.64997 11.2813Z",
    fill: "#355C9D",
    stroke: "#355C9D",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.64997 14C8.64997 13.9862 8.63878 13.975 8.62497 13.975C8.61115 13.975 8.59997 13.9862 8.59997 14C8.59997 14.0138 8.61115 14.025 8.62497 14.025C8.63878 14.025 8.64997 14.0138 8.64997 14Z",
    fill: "#355C9D",
    stroke: "#355C9D",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62497 7.9375C8.27978 7.9375 7.99997 8.21732 7.99997 8.5625C7.99997 8.90769 8.27978 9.1875 8.62497 9.1875C8.97015 9.1875 9.24997 8.90769 9.24997 8.5625C9.24997 8.21732 8.97015 7.9375 8.62497 7.9375Z",
    fill: "#355C9D",
    stroke: "#355C9D",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.24997 11.2813C9.24997 10.9361 8.97015 10.6563 8.62497 10.6563C8.27978 10.6563 7.99997 10.9361 7.99997 11.2813C7.99997 11.6264 8.27978 11.9062 8.62497 11.9062C8.97015 11.9062 9.24997 11.6264 9.24997 11.2813Z",
    fill: "#355C9D",
    stroke: "#355C9D",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.24997 14C9.24997 13.6548 8.97015 13.375 8.62497 13.375C8.27978 13.375 7.99997 13.6548 7.99997 14C7.99997 14.3452 8.27978 14.625 8.62497 14.625C8.97015 14.625 9.24997 14.3452 9.24997 14Z",
    fill: "#355C9D",
    stroke: "#355C9D",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.90625 2.62501V5.125",
    stroke: "#355C9D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 5.125V2.62501",
    stroke: "#355C9D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9687 11.2813C11.9687 10.9361 11.6889 10.6563 11.3437 10.6563C10.9985 10.6563 10.7187 10.9361 10.7187 11.2813C10.7187 11.6264 10.9985 11.9062 11.3437 11.9062C11.6889 11.9062 11.9687 11.6264 11.9687 11.2813Z",
    fill: "#355C9D",
    stroke: "#355C9D",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6875 11.2813C14.6875 10.9361 14.4077 10.6563 14.0625 10.6563C13.7173 10.6563 13.4375 10.9361 13.4375 11.2813C13.4375 11.6264 13.7173 11.9062 14.0625 11.9062C14.4077 11.9062 14.6875 11.6264 14.6875 11.2813Z",
    fill: "#355C9D",
    stroke: "#355C9D",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96872 2.62501V5.125",
    stroke: "#355C9D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8449 15.158L12.8393 17.1043C13.2557 17.5005 13.9218 17.4561 14.2818 17.0081L17.375 12.6875",
    stroke: "#355C9D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarJob);
export default __webpack_public_path__ + "static/media/calendar-job.626258850e9b17816057a5323fe69da1.svg";
export { ForwardRef as ReactComponent };